import {
     Component, HostBinding, ChangeDetectionStrategy, ViewEncapsulation, OnInit, OnChanges, ElementRef,
    } from '@angular/core';
import { UxAppShellService } from '@eui/core';

@Component({
    selector: 'eui-header-app-name',
    templateUrl: './header-app-name.component.html',
    changeDetection: ChangeDetectionStrategy.Default,
    encapsulation: ViewEncapsulation.None,
})
export class EuiHeaderAppNameComponent implements OnInit, OnChanges {

    @HostBinding('class') string = 'eui-header-app-name';

    constructor(
        public asService: UxAppShellService,
        private elRef: ElementRef,
    ) {
    }

    ngOnInit() {
        this.asService.setState({
            ...this.asService.state,
            appName: this.elRef.nativeElement.textContent,
        });
    }

    ngOnChanges() {
        this.asService.setState({
            ...this.asService.state,
            appName: this.elRef.nativeElement.textContent,
        });
    }
}
